// extracted by mini-css-extract-plugin
module.exports = {"authLoginUserIcon":"AuthStatus-hashed__authLoginUserIcon__WNjCl","authLoginUserName":"AuthStatus-hashed__authLoginUserName__37p7n"};